<ng-container *ngIf="this.isLoading || !this.isHomepageLoaded">
  <skeleton-slider></skeleton-slider>
  <skeleton-engine></skeleton-engine>
  <div class="container my-4">
    <div class="row">
      <div class="col-12 col-lg-4">
        <skeleton-card-home></skeleton-card-home>
      </div>
      <div class="col-12 col-lg-4">
        <skeleton-card-home></skeleton-card-home>
      </div>
      <div class="col-12 col-lg-4">
        <skeleton-card-home></skeleton-card-home>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!this.cmsHome && this.isHomepageLoaded">
  <!-- componenti homepage statici (no cms) -->
  <!-- <app-home-engine-container-slider></app-home-engine-container-slider>
  <section class="wrapper-content">
    <app-home-specials></app-home-specials>
    <app-home-banner-full></app-home-banner-full>
    <app-home-appointments *ngIf="hasAppointments$ | async"></app-home-appointments>
    <app-home-newsletter></app-home-newsletter>
    <app-home-destinations></app-home-destinations>
    <app-home-news></app-home-news>
    <app-home-utilities></app-home-utilities>
  </section> -->
</ng-container>

<ng-container *ngIf="this.cmsHome && this.isHomepageLoaded">
  <c-page [page]="this.cmsHome"></c-page>
</ng-container>




